import IncTextField from 'components/forms/fields/inc-text-field/inc-text-field.component';
import { useTranslation } from 'react-i18next';
import { useMapsGeo } from '../../address-form.hooks';

const LongitudeField = ({ name, ...rest }) => {
  const { t } = useTranslation();
  useMapsGeo(name, 'longitude');

  return (
    <IncTextField
      name={name}
      label={t('forms.fields.longitude.label')}
      data-testid="LongitudeField"
      {...rest}
    />
  );
};
export default LongitudeField;
